import { Fancybox } from "@fancyapps/ui";

export default {
    init: function() {
        // Check if any fancybox elements exist before initializing
        if (document.querySelector('[data-fancybox]')) {
            Fancybox.bind('[data-fancybox]', {
                buttons: ['slideShow', 'thumbs', 'zoom', 'fullScreen', 'share', 'close'],
                loop: false,
                protect: true
            });
        }

        if (document.querySelector('[data-fancybox-single]')) {
            Fancybox.bind('[data-fancybox-single]', {
                buttons: ['thumbs', 'zoom', 'fullScreen', 'share', 'close'],
                loop: false,
                protect: true
            });
        }

        if (document.querySelector('[data-fancybox="gallery"]')) {
            Fancybox.bind('[data-fancybox="gallery"]', {
                // Default options
                Thumbs: false,
            });
        }
    }
};
